import React from 'react';
import { useSelector } from 'react-redux';
import { getVehicleDetails } from '~/selectors';

type OwnProps = React.HTMLAttributes<HTMLAnchorElement> &
  React.PropsWithChildren<{
    'data-analytics-id': string;
  }>;

export default function CarfaxLink({
  children,
  'data-analytics-id': dataAnalyticsId,
  ...props
}: OwnProps) {
  const { vin } = useSelector(getVehicleDetails);

  return (
    <a
      href={`https://www.carfax.com/VehicleHistory/p/Report.cfx?partner=CVN_0&vin=${vin}`}
      target="_blank"
      rel="noopener noreferrer"
      data-analytics-id={dataAnalyticsId}
      data-native-payload={JSON.stringify({ vin })}
      {...props}
    >
      {children}
    </a>
  );
}
